import React, { forwardRef, Ref } from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { IconProps } from './index'

const EthereumIcon = (props: IconProps, ref: Ref<any>) => {
  const { className, ...restProps } = props
  return (
    <SvgIcon
      className={className}
      ref={ref}
      {...restProps}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M12.1378 2L6 12.1854L12.1378 9.39567V2Z" fill="#8A92B2" />
      <path d="M12.1378 9.39563L6 12.1853L12.1378 15.8144V9.39563Z" fill="#62688F" />
      <path d="M18.2769 12.1854L12.1379 2V9.39567L18.2769 12.1854Z" fill="#62688F" />
      <path d="M12.1379 15.8144L18.2769 12.1853L12.1379 9.39563V15.8144Z" fill="#454A75" />
      <path d="M6 13.3499L12.1378 22V16.9767L6 13.3499Z" fill="#8A92B2" />
      <path d="M12.1379 16.9767V22L18.2802 13.3499L12.1379 16.9767Z" fill="#62688F" />
    </SvgIcon>
  )
}

export default forwardRef(EthereumIcon)
